export default "__VITE_ASSET__BgSb0opS__";